import React, { useState } from 'react';

import { Box, Grid, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import StyledIntroduction from './styles';

import PhoneImage from '../../../assets/images/home/iPhone-Mockup.png';
import JadeGIF from '../../../assets/video/UX_2-min.gif';

// const introductionText1 =
//   'Even though the employees are working hard <br/>if sales do not increase, <br/> there may be a problem with the "solution." <br/> <span className="bold">Just changing the solution can increase sales.</span>';

// const introductionText2 =
//   "We didn't start unless it was the best.<br/>We challenge the best of the system with 20 years of accumulated know-how.";

// const introductionText3 = 'Let me introduce <span>Jade Soft</span>';

const Introduction = () => {
  const theme = useTheme();
  const { i18n, t } = useTranslation();
  const [changeOpacity, setChangeOpacity] = useState(false);

  const label1 = t('intro-label-one');
  const label2 = t('intro-label-two');
  const label2Mobile = t('intro-label-two');

  return (
    <StyledIntroduction>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'column', lg: 'row', xl: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? '120vh' : '90vh',
          backgroundColor: 'white',
          color: theme.palette.background.secondary,
          // px: 40,
          // paddingTop: 25,
          // paddingBottom: 20,
          paddingLeft: 20,
          paddingRight: 20,
          [theme.breakpoints.down('lg')]: {
            // px: 1,
            // py: 1,
            // minHeight: '87vh',
            justifyContent: 'center',
            padding: '10% 5%',
          },
        }}
      >
        <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0, lg: 5, xl: 5 }}>
          {/* Left Content */}
          <Grid item xs={12} md={12} lg={7} xl={7}>
            {/* <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' }, zIndex: 1 }}> */}
            <motion.div
              initial={{
                opacity: 0,
                x: 100,
              }}
              whileInView={{
                opacity: 1,
                x: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                },
              }}
            // viewport={{ once: true }}
            >
              <Box
                sx={{
                  display: { xs: 'flex', md: 'flex', lg: 'none', xl: 'none' },
                  flex: 1,
                  // display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                  //  marginTop: -15,
                  // marginRight: 5,
                  [theme.breakpoints.down('lg')]: {
                    marginTop: -5,
                  }
                }}
              >
                {/* Replace with actual image */}
                <img
                  src={PhoneImage}
                  alt="Jade Soft Graphics"
                  style={{
                    width: '400px',
                    height: '386px',
                    // maxWidth: '100%',
                    // height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            </motion.div>
            <motion.div
              initial={{
                opacity: 0,
                x: -100,
              }}
              whileInView={{
                opacity: 1,
                x: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                  delay: 0.8,
                },
              }}
            // viewport={{ once: true }}
            >
              <Box
                component="img"
                src={JadeGIF}
                sx={{
                  width: '550px',
                  height: '345px',
                  marginLeft: '-45px',
                  [theme.breakpoints.down('lg')]: {
                    width: '100%',
                    height: 'auto',
                    display: 'flex',
                    justifySelf: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '-60px',
                    marginLeft: 'unset',
                  },
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  mt: 1,
                  mb: 2,
                  // ml: 5,
                  lineHeight: '47.73px',
                  wordWrap: 'break-word',
                  fontWeight: 800,
                  fontSize: '40px',
                  color: '#444444',
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '25px',
                    textAlign: 'center',
                  },
                }}
              >
                {label1}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  // ml: 5,
                  lineHeight: '23.87px',
                  // wordWrap: 'break-word',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '600' : '700',
                  fontSize: '20px',
                  color: '#676767',
                  [theme.breakpoints.down('lg')]: {
                    display: 'none',
                  },
                }}
              >
                {parse(label2)}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  // ml: 5,
                  lineHeight: '26px',
                  // wordWrap: 'break-word',
                  fontWeight: 800,
                  fontSize: '20px',
                  color: '#676767',
                  display: 'none',
                  [theme.breakpoints.down('lg')]: {
                    display: 'flex',
                    fontSize: '18px',
                    fontWeight: 500,
                    lineHeight: '21.48px',
                    textAlign: 'center',
                    justifyContent: 'center',
                  },
                }}
                className='label2'
              >
                {parse(label2Mobile)}
              </Typography>
            </motion.div>
          </Grid>
          {/* Right Content */}
          <Grid item xs={12} md={12} lg={5} xl={5}>
            <motion.div
              initial={{
                opacity: 0,
                x: 100,
              }}
              whileInView={{
                opacity: 1,
                x: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                  delay: 0.8,
                },
              }}
            // viewport={{ once: true }}
            >
              <Box
                sx={{
                  display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' },
                  flex: 1,
                  // display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                  // marginTop: -15,
                  marginRight: 5,
                }}
              >
                {/* Replace with actual image */}
                <img
                  src={PhoneImage}
                  alt="Jade Soft Graphics"
                  style={{
                    width: '889px',
                    height: '824px',
                    // maxWidth: '100%',
                    // height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Box>
      {/* <Wave
        fill="#000000"
        paused={false}
        style={{ display: 'flex', marginTop: '-40px', height: '50px' }}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3,
        }}
      /> */}
    </StyledIntroduction>
  );
};

export default Introduction;
